
import {defineComponent} from "vue";
import authStore from "@/store/auth";

export default defineComponent({
  name: 'TripPageLayout',
  components: {},
  setup: function () {
    const {
      authState
    } = authStore

    return {
      authState
    }
  },
})
